module.exports = __webpack_public_path__ + "static/media/IMG_8933.ea5fe639.JPG";